module.exports = __webpack_public_path__ + "static/media/auri.83e40ee5.png";